import * as React from "react";
import type { SVGProps } from "react";
const SvgYoutubeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.581 7.07c-.466-1.53-.832-2.378-2.375-2.562 0 0-4.132-.208-8.241-.208-4.062 0-8.102.208-8.102.208-1.636.184-2.025 1.079-2.444 2.563 0 0-.419 2.363-.419 4.756 0 2.454.419 4.94.419 4.94.326 1.438.995 2.379 2.444 2.563 0 0 4.484.278 8.754.278 3.883 0 7.59-.278 7.59-.278 1.45-.277 1.955-1.032 2.374-2.562 0 0 .419-2.273.419-4.618 0-2.499-.419-5.08-.419-5.08ZM9.801 16.01V7.836l6.355 4.086L9.8 16.01Z"
    />
  </svg>
);
export default SvgYoutubeIcon;
